import { Filter as CommonFilter, FilterProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { getFilterConfig } from './config';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';
import { useCan } from 'src/utils/can';

export const Filter = (props: Omit<FilterProps, 'items'>) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'lms.certificates.list',
  });

  const { can } = useCan();

  const canWrite = can({
    action: Actions.Write,
    appArea: AppArea.Lms,
    subject: Subjects.Certificates,
  });

  const filterConfig = getFilterConfig({ t, canWrite });

  return (
    <CommonFilter
      {...props}
      items={filterConfig}
      searchInputProps={{
        placeholder: t('filter.search.placeholder'),
      }}
    />
  );
};
